module.exports = "/_next/static/images/aa91c4c09d4f20013d8fa4d352cc134b-cards-and-device@0.75x.jpg";